/**
 * Privileged service credentials must never be shipped in a browser bundle.
 *
 * Storage mutations remain fail-closed until the API accepts a real user
 * identity and enforces object ownership. Public reads are intentionally
 * keyless.
 */
export const CLOUD_WRITE_DISABLED_MESSAGE =
  'Cloud writing is temporarily unavailable while secure user authentication is being enabled.';

export function rejectInsecureCloudMutation(): never {
  throw new Error(CLOUD_WRITE_DISABLED_MESSAGE);
}
